import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateBrandingPayload {
    data: {
        logoImage: string
        bgImage: string
        bgPattern: string
        colorCode: string
        paletteColor: string
        logoColor: string
    }
    sagaCB?: {
        onSuccess: any
    }
}

export interface ICreateBrandingState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateBrandingState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createBranding = createSlice({
    name: 'branding/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateBrandingPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createBrandingActions = createBranding.actions
export default createBranding.reducer
